import React, { createContext, useEffect, useState } from 'react';
import { fetchFeatureFlags } from 'src/actions/featureFlagActions';

const FeatureFlagContext = createContext({
    featureFlags: [],
    setFeatureFlags: () => { }
});

export const FeatureFlagProvider = ({ children }) => {
    const [featureFlags, setFeatureFlags] = useState([]);

    useEffect(() => {
        fetchFeatureFlags().then(setFeatureFlags);
    }, []);

    return <FeatureFlagContext.Provider value={{ featureFlags, setFeatureFlags }}>{children}</FeatureFlagContext.Provider>;
};

export default FeatureFlagContext;
